import React, {useState} from 'react';
import {Spinner} from "react-bootstrap";
import FullLoader from "../Loader/FullLoader";

function AlertJobGraphsModal(props) {
    const { show, content, loading, onClick } = props;
    
    const onClickX = (e) => {
        onClick && onClick(e);
    }
    
    let loader = loading ? <FullLoader /> : null;
    
    return(
        <div className="fullscreen-modal" style={{ display: show ? "block" : "none" }}>
            <div className="big-modal-wrapper"
                 style={{
                     transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: show ? '1' : '0'
                 }}>

                <div className="modal-header" >
                    <h3>Alert Graphs</h3>
                    <span className="close-modal-btn" onClick={e => { onClickX(e);  }}>×</span>
                </div>

                <div className="modal-body text-center justify-content-center">

                    {content}
                    {loader}

                </div>

                <div className="modal-footer">
                    <button className="secondary-btn btn-small" onClick={e => { onClickX(e); }}>Close</button>
                </div>
            </div>
        </div>
    )
    
}
export default AlertJobGraphsModal;